import { QueovalBase } from '../global';
import { Select } from '../utilities';
import { Convention } from './convention';

export class ControleConventionModel extends QueovalBase {
  public ConventionSelected: Convention;
  public ListNumeroStage: Select[];
  public ListTypeStage: Select[];
  public ListCycle: Select[];
}
